export var ColdTierSearchSubjects;
(function (ColdTierSearchSubjects) {
    ColdTierSearchSubjects["EmptyState"] = "cold-search-empty-state";
    ColdTierSearchSubjects["FirstQueryState"] = "cold-search-first-query-state";
    ColdTierSearchSubjects["PageContainer"] = "cold-search-container";
    ColdTierSearchSubjects["ReingestButton"] = "reingest-button";
    ColdTierSearchSubjects["ReingestConfirmButton"] = "reingest-confirm-button";
    ColdTierSearchSubjects["PermissionsNotification"] = "cold-search-permissions-notification";
    ColdTierSearchSubjects["AdminReingestModal"] = "admin-reingest-modal";
})(ColdTierSearchSubjects || (ColdTierSearchSubjects = {}));
export var ColdTierStates;
(function (ColdTierStates) {
    ColdTierStates["None"] = "NONE";
    ColdTierStates["LogzioInternal"] = "LOGZIO_INTERNAL";
    ColdTierStates["ExternalAWS"] = "EXTERNAL_AWS";
})(ColdTierStates || (ColdTierStates = {}));
//# sourceMappingURL=cold-tier-search.enum.js.map